export default __webpack_public_path__ + "static/media/mysql-backup-negative.0c1b840d.svg";